import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { setToken, setUserInfo } from './features/auth/authSlice'
import Authentication from './components/Pages/Authentication'
import jwt_decode from 'jwt-decode'
import Header from './components/layout/Header/Header'
import Conversations from './components/layout/Sidebar/Conversations'
import Footer from './components/layout/Footer/Footer'
import WhatsProfile from './components/Pages/smallComponents/WhatsProfile'
import Settings from './components/Pages/smallComponents/Settings'
import MyProfile from './components/Pages/smallComponents/MyProfile'
import { Contact } from 'lucide-react'
import Contacts from './components/Pages/smallComponents/Contacts'
import Stories from './components/Pages/smallComponents/Stories'
import Community from './components/Pages/smallComponents/Community'
import Explore from './components/layout/Sidebar/Explore'
import Loginscreen from './components/Pages/smallComponents/Loginscreen'
import { setNotification } from '../src/features/data/dataSlice'
import Login from './components/Pages/Login'

const App = ({ authToken, setToken, setUserInfo, setNotification }) => {
  const validateToken = () => {
    if (authToken) {
      return true
    } else {
      const token = localStorage.getItem('authToken')
      const user = JSON.parse(localStorage.getItem('userInfo'))
      // const notify = JSON.parse(localStorage.getItem('notification'))
      const tokenData = token ? jwt_decode(token) : false
      console.log(new Date(tokenData.exp * 1000), new Date())
      if (tokenData && new Date(tokenData.exp * 1000) > new Date()) {
        // if (
        //   tokenData.hasOwnProperty('ID') &&
        //   tokenData.hasOwnProperty('RoleID')
        // ) {
        setToken({ authToken: token })
        //   return true
        // } else {
        //   localStorage.clear()
        //   return false
        // }
        setToken(token)
        setUserInfo(user)
        // setNotification(notify)
        return true
      } else {
        // localStorage.clear()
        return false
      }
    }
  }
  const userLoggedIn = validateToken()
  // console.log(userLoggedIn)

  return (
    <div className="App" style={{ height: '-webkit-fill-available' }}>
      <BrowserRouter>
        <Routes>
          {!userLoggedIn && (
            <Fragment>
              <Route path="*" element={<LoginScreenView />} />
            </Fragment>
          )}
          {userLoggedIn && (
            <Fragment>
              <Route path="*" element={<LoginScreenView />} />
              <Route path="/" element={<ConversationsView />} />
              <Route path="/dashboard" element={<ConversationsView />} />
              <Route path="/profile" element={<WhatsProfile />} />{' '}
              <Route path="/myprofile" element={<MyProfile />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/stories" element={<StoriesView />} />
              <Route path="/community" element={<CommunityView />} />
              <Route path="/explore" element={<ExploreView />} />
            </Fragment>
          )}
        </Routes>
      </BrowserRouter>
    </div>
  )
}

function Auth() {
  return (
    <div className="App pt-5">
      <Authentication />
    </div>
  )
}

function LoginScreenView() {
  return <Login />
}

function ConversationsView() {
  return (
    <>
      {/* <Header /> */}
      <Conversations />
      {/* <Footer /> */}
    </>
  )
}
function StoriesView() {
  return (
    <div>
      <Stories />
      <Footer />
    </div>
  )
}
function CommunityView() {
  return (
    <div>
      <Community />
      {/* <Footer /> */}
    </div>
  )
}

function ExploreView() {
  return (
    <div>
      <Header />
      <Explore />
      <Footer />
    </div>
  )
}

const mapStateToProps = ({ auth }) => {
  const { authToken } = auth

  return {
    authToken
  }
}

const mapDispatchToProps = {
  setToken,
  setUserInfo,
  setNotification
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
